/**
 * MAP (in-file navigation graph — any LLM reads this without external tooling;
 * keep in sync with the code):
 *   role:      controller — redeem a voucher code and hand it to the index
 *              controller before jumping to product selection
 *   extends:   Controller (@ember/controller)
 *   template:  none
 *   qp:        code
 *   key:       getVoucherTask, setVoucher action
 *   uses:      beebee-base/lib/utility (beebeeAjaxPost), beebee-base/lib/get-config,
 *              services: notify/router/intl/session, applicationController
 *   siblings:  routes/use-voucher.js, templates/use-voucher.hbs
 *   tests:     controllers-logic-test.js, wave7-coverage-test.js,
 *              module-contracts-test.js
 *
 * Looks up a voucher by its `code` query param via `booking_get_voucher`,
 * then on selection stores it on applicationController.voucherToUse and
 * transitions into the index booking flow for the chosen product.
 */
import Controller from '@ember/controller';

import { action, set } from '@ember/object';
import { beebeeAjaxPost } from 'beebee-base/lib/utility';
import { task } from 'ember-concurrency';

import { inject as iService } from '@ember/service';

import { inject as iController } from '@ember/controller';

import getConfig from 'beebee-base/lib/get-config';
export default class UseVoucherController extends Controller {
  @iService notify;
  queryParams = ['code'];
  @iService router;
  @iService intl;
  @iService session;
  @iController('application') applicationController;

  @(task(function* () {
    if (!this.code) {
      return;
    }

    set(this, 'voucherLists', null);
    set(this, 'voucherAPI', null);

    try {
      const voucherAPI = yield beebeeAjaxPost(`${getConfig(this).APP.urlApi}/booking_get_voucher`, null, {
        code: this.code,
      });

      if (!voucherAPI?.products) {
        this.notify.warning(this.intl.t('voucher.not_valid'));
      } else {
        set(this, 'voucherAPI', voucherAPI);
      }
    } catch (e) {
      this.notify.warning(this.intl.t('voucher.not_valid'));
    }
  }).restartable())
  getVoucherTask;

  @action
  setVoucher(p, e) {
    set(this, 'applicationController.voucherToUse', this.voucherAPI);

    this.router.transitionTo('index', {
      queryParams: {
        product: p.id,
      },
    });
  }

  @action
  clickLogo() {}
}
